import { useState } from "react";

function GovernanceTab() {
  const [activeSection, setActiveSection] = useState("dashboard");

  // Sample data
  const governanceRoles = [
    { role: "MLRO (Money Laundering Reporting Officer)", assignee: "Sarah Johnson", contact: "sarah.j@company.ae" },
    { role: "Board Compliance Committee", assignee: "Ahmed Al Mansoori (Chair)", contact: "ahmed.m@company.ae" },
    { role: "Compliance Officer", assignee: "Marina Ibrahim", contact: "marina.i@company.ae" },
    { role: "Internal Audit", assignee: "John Smith", contact: "john.s@company.ae" }
  ];

  const recentReports = [
    { id: "STR-2025-001", type: "Suspicious Transaction Report", date: "2025-09-28", status: "Filed", urgency: "High" },
    { id: "TR-2025-042", type: "Threshold Transaction Report", date: "2025-09-25", status: "Filed", urgency: "Normal" },
    { id: "BR-2025-Q3", type: "Board Report - Q3 2025", date: "2025-09-30", status: "Approved", urgency: "Normal" },
    { id: "TR-2025-15", type: "Training Completion Report", date: "2025-09-20", status: "Filed", urgency: "Normal" }
  ];

  const complianceKPIs = [
    { metric: "STRs Filed (YTD)", value: "12", target: "N/A", status: "on-track" },
    { metric: "Staff Training Completion", value: "95%", target: "100%", status: "on-track" },
    { metric: "Policy Review Compliance", value: "100%", target: "100%", status: "on-track" },
    { metric: "Customer Screening Coverage", value: "100%", target: "100%", status: "on-track" },
    { metric: "High-Risk Customer Reviews", value: "100%", target: "100%", status: "on-track" },
    { metric: "Audit Findings Closed", value: "8/10", target: "10/10", status: "at-risk" }
  ];

  const renderDashboard = () => (
    <div>
      <h2 style={{ color: "#0d47a1", marginBottom: 20 }}>Governance & Reporting Dashboard</h2>
      
      {/* KPI Summary Cards */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 20, marginBottom: 30 }}>
        <div style={{ background: "white", padding: 20, borderRadius: 8, boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
          <h3 style={{ color: "#1976d2", margin: 0, fontSize: 32 }}>12</h3>
          <p style={{ color: "#666", margin: "5px 0 0 0" }}>STRs Filed (2025)</p>
        </div>
        <div style={{ background: "white", padding: 20, borderRadius: 8, boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
          <h3 style={{ color: "#4caf50", margin: 0, fontSize: 32 }}>95%</h3>
          <p style={{ color: "#666", margin: "5px 0 0 0" }}>Training Compliance</p>
        </div>
        <div style={{ background: "white", padding: 20, borderRadius: 8, boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
          <h3 style={{ color: "#ff9800", margin: 0, fontSize: 32 }}>125</h3>
          <p style={{ color: "#666", margin: "5px 0 0 0" }}>Active Customers</p>
        </div>
        <div style={{ background: "white", padding: 20, borderRadius: 8, boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
          <h3 style={{ color: "#9c27b0", margin: 0, fontSize: 32 }}>0</h3>
          <p style={{ color: "#666", margin: "5px 0 0 0" }}>Overdue Actions</p>
        </div>
      </div>

      {/* Quick Actions */}
      <div style={{ display: "flex", gap: 15, marginBottom: 30 }}>
        <button
          onClick={() => setActiveSection("roles")}
          style={{
            backgroundColor: "#1976d2",
            color: "white",
            border: "none",
            padding: "12px 24px",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: 15,
            fontWeight: "bold"
          }}
        >
          Governance Framework
        </button>
        <button
          onClick={() => setActiveSection("escalation")}
          style={{
            backgroundColor: "#f44336",
            color: "white",
            border: "none",
            padding: "12px 24px",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: 15,
            fontWeight: "bold"
          }}
        >
          Escalation Workflow
        </button>
        <button
          onClick={() => setActiveSection("reports")}
          style={{
            backgroundColor: "#4caf50",
            color: "white",
            border: "none",
            padding: "12px 24px",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: 15,
            fontWeight: "bold"
          }}
        >
          Reports & KPIs
        </button>
      </div>

      {/* Recent Reports */}
      <h3 style={{ color: "#0d47a1", marginBottom: 15 }}>Recent Regulatory Reports</h3>
      <table style={{ width: "100%", borderCollapse: "collapse", background: "white", boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
        <thead>
          <tr style={{ backgroundColor: "#0d47a1", color: "white" }}>
            <th style={{ border: "1px solid #ccc", padding: "12px", textAlign: "left" }}>Report ID</th>
            <th style={{ border: "1px solid #ccc", padding: "12px", textAlign: "left" }}>Type</th>
            <th style={{ border: "1px solid #ccc", padding: "12px", textAlign: "left" }}>Date</th>
            <th style={{ border: "1px solid #ccc", padding: "12px", textAlign: "left" }}>Status</th>
            <th style={{ border: "1px solid #ccc", padding: "12px", textAlign: "left" }}>Urgency</th>
          </tr>
        </thead>
        <tbody>
          {recentReports.map((report) => (
            <tr key={report.id}>
              <td style={{ border: "1px solid #ccc", padding: "12px" }}>{report.id}</td>
              <td style={{ border: "1px solid #ccc", padding: "12px" }}>{report.type}</td>
              <td style={{ border: "1px solid #ccc", padding: "12px" }}>{report.date}</td>
              <td style={{ border: "1px solid #ccc", padding: "12px" }}>
                <span style={{
                  backgroundColor: report.status === "Filed" ? "#4caf50" : "#1976d2",
                  color: "white",
                  padding: "4px 12px",
                  borderRadius: "12px",
                  fontSize: "13px"
                }}>
                  {report.status}
                </span>
              </td>
              <td style={{ border: "1px solid #ccc", padding: "12px" }}>
                <span style={{ color: report.urgency === "High" ? "#f44336" : "#666", fontWeight: report.urgency === "High" ? "bold" : "normal" }}>
                  {report.urgency}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  const renderRoles = () => (
    <div>
      <button
        onClick={() => setActiveSection("dashboard")}
        style={{
          backgroundColor: "#ccc",
          color: "#333",
          border: "none",
          padding: "8px 16px",
          borderRadius: "5px",
          cursor: "pointer",
          marginBottom: 20
        }}
      >
        ← Back to Dashboard
      </button>
      
      <h2 style={{ color: "#0d47a1", marginBottom: 20 }}>Governance Framework</h2>
      
      <div style={{ background: "white", padding: 30, borderRadius: 8, boxShadow: "0 2px 4px rgba(0,0,0,0.1)", marginBottom: 30 }}>
        <h3 style={{ color: "#0d47a1", marginBottom: 20 }}>Key Roles & Responsibilities</h3>
        
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ backgroundColor: "#f5f5f5" }}>
              <th style={{ border: "1px solid #ddd", padding: "12px", textAlign: "left" }}>Role</th>
              <th style={{ border: "1px solid #ddd", padding: "12px", textAlign: "left" }}>Assignee</th>
              <th style={{ border: "1px solid #ddd", padding: "12px", textAlign: "left" }}>Contact</th>
            </tr>
          </thead>
          <tbody>
            {governanceRoles.map((item, index) => (
              <tr key={index}>
                <td style={{ border: "1px solid #ddd", padding: "12px", fontWeight: "bold" }}>{item.role}</td>
                <td style={{ border: "1px solid #ddd", padding: "12px" }}>{item.assignee}</td>
                <td style={{ border: "1px solid #ddd", padding: "12px" }}>{item.contact}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={{ background: "white", padding: 30, borderRadius: 8, boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
        <h3 style={{ color: "#0d47a1", marginBottom: 20 }}>Governance Structure</h3>
        <p style={{ lineHeight: 1.8, color: "#555", marginBottom: 20 }}>
          The AML governance framework is structured in accordance with UAE AML Law (Art. 18) and FATF Recommendation 18. 
          The Board of Directors has ultimate responsibility for AML compliance, with day-to-day oversight delegated to the MLRO.
        </p>

        <h4 style={{ color: "#0d47a1" }}>Oversight Levels:</h4>
        <ul style={{ lineHeight: 2, color: "#555" }}>
          <li><strong>Board Level:</strong> Quarterly compliance reports, annual policy review, strategic oversight</li>
          <li><strong>MLRO:</strong> Day-to-day compliance management, regulatory liaison, STR filing authority</li>
          <li><strong>Compliance Officer:</strong> Operational execution, customer screening, training coordination</li>
          <li><strong>Internal Audit:</strong> Independent review, testing, regulatory readiness assessments</li>
        </ul>
      </div>
    </div>
  );

  const renderEscalation = () => (
    <div>
      <button
        onClick={() => setActiveSection("dashboard")}
        style={{
          backgroundColor: "#ccc",
          color: "#333",
          border: "none",
          padding: "8px 16px",
          borderRadius: "5px",
          cursor: "pointer",
          marginBottom: 20
        }}
      >
        ← Back to Dashboard
      </button>
      
      <h2 style={{ color: "#0d47a1", marginBottom: 20 }}>Escalation Workflow</h2>
      
      <div style={{ background: "white", padding: 30, borderRadius: 8, boxShadow: "0 2px 4px rgba(0,0,0,0.1)", marginBottom: 30 }}>
        <h3 style={{ color: "#0d47a1", marginBottom: 20 }}>Suspicious Activity Escalation Chain</h3>
        
        <div style={{ display: "flex", alignItems: "center", gap: 20, marginBottom: 30 }}>
          <div style={{ flex: 1, background: "#e3f2fd", padding: 20, borderRadius: 8, textAlign: "center" }}>
            <h4 style={{ margin: 0, color: "#1976d2" }}>Step 1</h4>
            <p style={{ margin: "10px 0 0 0" }}>Front-line Staff / Agent</p>
            <p style={{ fontSize: 13, color: "#666", margin: "5px 0 0 0" }}>Identifies suspicious activity</p>
          </div>
          <div style={{ fontSize: 24, color: "#1976d2" }}>→</div>
          <div style={{ flex: 1, background: "#fff3e0", padding: 20, borderRadius: 8, textAlign: "center" }}>
            <h4 style={{ margin: 0, color: "#ff9800" }}>Step 2</h4>
            <p style={{ margin: "10px 0 0 0" }}>Compliance Officer</p>
            <p style={{ fontSize: 13, color: "#666", margin: "5px 0 0 0" }}>Initial review & documentation</p>
          </div>
          <div style={{ fontSize: 24, color: "#ff9800" }}>→</div>
          <div style={{ flex: 1, background: "#fce4ec", padding: 20, borderRadius: 8, textAlign: "center" }}>
            <h4 style={{ margin: 0, color: "#e91e63" }}>Step 3</h4>
            <p style={{ margin: "10px 0 0 0" }}>MLRO</p>
            <p style={{ fontSize: 13, color: "#666", margin: "5px 0 0 0" }}>Final assessment & decision</p>
          </div>
          <div style={{ fontSize: 24, color: "#e91e63" }}>→</div>
          <div style={{ flex: 1, background: "#ffebee", padding: 20, borderRadius: 8, textAlign: "center" }}>
            <h4 style={{ margin: 0, color: "#f44336" }}>Step 4</h4>
            <p style={{ margin: "10px 0 0 0" }}>goAML Platform</p>
            <p style={{ fontSize: 13, color: "#666", margin: "5px 0 0 0" }}>STR filing to FIU</p>
          </div>
        </div>

        <div style={{ padding: 15, backgroundColor: "#fff3cd", borderLeft: "4px solid #ff9800", borderRadius: 5 }}>
          <strong>Timeline SLA:</strong> Suspicious activities must be escalated to MLRO within 24 hours of identification. 
          STR filing to goAML must be completed within 3 business days of MLRO approval.
        </div>
      </div>

      <div style={{ background: "white", padding: 30, borderRadius: 8, boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
        <h3 style={{ color: "#0d47a1", marginBottom: 20 }}>Escalation Triggers</h3>
        <ul style={{ lineHeight: 2, color: "#555" }}>
          <li>Transactions inconsistent with customer profile or business activity</li>
          <li>Unusual cash deposits or withdrawals above AED 55,000</li>
          <li>Rapid movement of funds through accounts (layering)</li>
          <li>Transactions involving high-risk jurisdictions without clear business rationale</li>
          <li>Customer reluctance to provide required documentation or information</li>
          <li>Sanctions or PEP screening hits requiring investigation</li>
          <li>Structuring of transactions to avoid reporting thresholds</li>
        </ul>
      </div>
    </div>
  );

  const renderReports = () => (
    <div>
      <button
        onClick={() => setActiveSection("dashboard")}
        style={{
          backgroundColor: "#ccc",
          color: "#333",
          border: "none",
          padding: "8px 16px",
          borderRadius: "5px",
          cursor: "pointer",
          marginBottom: 20
        }}
      >
        ← Back to Dashboard
      </button>
      
      <h2 style={{ color: "#0d47a1", marginBottom: 20 }}>Reports & KPIs</h2>
      
      <div style={{ background: "white", padding: 30, borderRadius: 8, boxShadow: "0 2px 4px rgba(0,0,0,0.1)", marginBottom: 30 }}>
        <h3 style={{ color: "#0d47a1", marginBottom: 20 }}>Compliance KPI Dashboard</h3>
        
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ backgroundColor: "#0d47a1", color: "white" }}>
              <th style={{ border: "1px solid #ccc", padding: "12px", textAlign: "left" }}>Metric</th>
              <th style={{ border: "1px solid #ccc", padding: "12px", textAlign: "center" }}>Current Value</th>
              <th style={{ border: "1px solid #ccc", padding: "12px", textAlign: "center" }}>Target</th>
              <th style={{ border: "1px solid #ccc", padding: "12px", textAlign: "center" }}>Status</th>
            </tr>
          </thead>
          <tbody>
            {complianceKPIs.map((kpi, index) => (
              <tr key={index}>
                <td style={{ border: "1px solid #ccc", padding: "12px" }}>{kpi.metric}</td>
                <td style={{ border: "1px solid #ccc", padding: "12px", textAlign: "center", fontWeight: "bold" }}>{kpi.value}</td>
                <td style={{ border: "1px solid #ccc", padding: "12px", textAlign: "center" }}>{kpi.target}</td>
                <td style={{ border: "1px solid #ccc", padding: "12px", textAlign: "center" }}>
                  <span style={{
                    backgroundColor: kpi.status === "on-track" ? "#4caf50" : "#ff9800",
                    color: "white",
                    padding: "4px 12px",
                    borderRadius: "12px",
                    fontSize: "13px"
                  }}>
                    {kpi.status === "on-track" ? "On Track" : "At Risk"}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={{ background: "white", padding: 30, borderRadius: 8, boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
        <h3 style={{ color: "#0d47a1", marginBottom: 20 }}>Regulatory Reporting Requirements</h3>
        
        <div style={{ marginBottom: 20 }}>
          <h4 style={{ color: "#1976d2" }}>Mandatory Reports</h4>
          <ul style={{ lineHeight: 2, color: "#555" }}>
            <li><strong>Suspicious Transaction Reports (STRs):</strong> Filed via goAML within 3 business days</li>
            <li><strong>Threshold Transaction Reports:</strong> Transactions over AED 55,000 (cash)</li>
            <li><strong>Board Compliance Reports:</strong> Quarterly submission to Board</li>
            <li><strong>Annual AML Training Reports:</strong> Staff training completion records</li>
            <li><strong>Customer Screening Logs:</strong> Daily sanctions/PEP screening documentation</li>
          </ul>
        </div>

        <div>
          <h4 style={{ color: "#1976d2" }}>Audit & Evidence Requirements</h4>
          <p style={{ lineHeight: 1.8, color: "#555" }}>
            All reports, approvals, and evidence must be maintained for a minimum of 5 years as per UAE AML Law (Art. 13). 
            Records must be retrievable within 2 business days for regulatory inspection.
          </p>
        </div>
      </div>
    </div>
  );

  return (
    <div style={{ padding: 20 }}>
      {activeSection === "dashboard" && renderDashboard()}
      {activeSection === "roles" && renderRoles()}
      {activeSection === "escalation" && renderEscalation()}
      {activeSection === "reports" && renderReports()}
    </div>
  );
}

export default GovernanceTab;